import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-32 text-center text-primary-dark font-bold" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "ご指定のページが見つかりません"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-10 text-3xl" }, "NOT FOUND")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-4 text-sm text-center" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 申し訳ありません。一時的にアクセスできない状態か、移動もしくは削除された可能性があります。 ")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}